<template>
    <MainContent title="Editar deportista">
        <EditarSkeleton v-if="loading" />

        <form v-else @submit.prevent="submit">
            <Card>
                <!-- Datos del menor -->
                <FormDatosMenor
                    :value="form"
                    :equipos="equipos"
                    :lateralidad-options="lateralidadOptions"
                    @change="onFieldChange"
                />

                <div class="tw:border-t tw:border-gray-100 tw:my-4"></div>

                <!-- Responsables -->
                <FormResponsablesEdit
                    :value="form"
                    @change="onFieldChange"
                />

                <div class="tw:border-t tw:border-gray-100 tw:my-4"></div>

                <!-- Foto -->
                <FormFotoEdit
                    :value="form"
                    :upload-url="fotoUploadUrl"
                    @upload-success="onFotoSuccess"
                />

                <div class="tw:border-t tw:border-gray-100 tw:my-4"></div>

                <!-- Actions -->
                <div class="tw:flex tw:justify-end tw:gap-3">
                    <Button
                        variant="ghost"
                        @click="goBack"
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        :disabled="submitting"
                        :loading="submitting"
                    >
                        {{ submitting ? 'Guardando...' : 'Guardar' }}
                    </Button>
                </div>
            </Card>
        </form>
    </MainContent>
</template>

<script setup>
    import { getCurrentInstance } from 'vue';
    import MainContent from '@/modules/admin/ui/MainContent.vue';
    import Card from '@/modules/admin/ui/Card.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import EditarSkeleton from '@/modules/admin/bases/components/EditarSkeleton.vue';
    import FormDatosMenor from '@/modules/admin/bases/forms/FormDatosMenor.vue';
    import FormResponsablesEdit from '@/modules/admin/bases/forms/FormResponsablesEdit.vue';
    import FormFotoEdit from '@/modules/admin/bases/forms/FormFotoEdit.vue';
    import { useEditarDeportista } from '@/composables/admin/bases/useEditarDeportista';

    const props = defineProps({
        lista_id: { type: [String, Number], required: true },
        base_id: { type: [String, Number], required: true },
    });

    const instance = getCurrentInstance();

    const {
        form,
        loading,
        submitting,
        error,
        equipos,
        lateralidadOptions,
        fotoUploadUrl,
        submit,
    } = useEditarDeportista(props, {
        onSaved() {
            instance.proxy.$router.push({
                name: 'back.bases.index',
                params: { lista_id: props.lista_id },
            });
        },
    });

    function onFieldChange({ field, value }) {
        form[field] = value;
    }

    function onFotoSuccess(response) {
        if (response?.url) {
            form.foto_perfil = response.url;
            form.foto_url = response.url;
        }
    }

    function goBack() {
        instance.proxy.$router.push({
            name: 'back.bases.index',
            params: { lista_id: props.lista_id },
        });
    }
</script>
